import React from 'react';
import { useModel } from '../../../hooks';
import { SiteNavContextProvider } from '../SiteNavHeader/SiteNavToggle/SiteNavContext';
import SiteNavHeader from '../SiteNavHeader';
import Header from '../../HeaderII';
import SiteMobilePrimaryNav from '../SiteNavHeader/SiteMobilePrimaryNav';

const SiteNavigationWrapper = () => {
  const { prismicSiteNavigationModel } = useModel();

  //TODO: When the new navigation is rolled out on all locales
  // we will need to deprecate this file and HeaderII.

  return prismicSiteNavigationModel ? (
    <SiteNavContextProvider>
      <SiteNavHeader navigation={prismicSiteNavigationModel} />
      <SiteMobilePrimaryNav mobileNavigation={prismicSiteNavigationModel} />
    </SiteNavContextProvider>
  ) : (
    <Header />
  );
};

export default SiteNavigationWrapper;
